/* eslint-disable react/prop-types */
import { Box } from '@digibee/beehive-ui';
import PropTypes from 'prop-types';

import * as Elements from './DeployPipelineDialog.elements';
import { useIsAutoscaling } from '../../../../hooks/useIsAutoscaling';
import { CardRuntime } from '../../../CardRuntime';

import CardLicense from '~/scenes/Runtime/components/CardLicense/CardLicense';

function DeployPipeline({
  environment,
  deployment,
  triggers,
  isRedeploy = false,
  folderPathView = true
}) {
  const showNewAutoScalingExperience = useIsAutoscaling();

  const licenseStatus =
    deployment?.licenseStatus || deployment?.pipeline?.licenseStatus || {};

  return (
    <Elements.Box top={20}>
      <CardRuntime
        disabledMenu
        deployment={deployment}
        triggers={triggers}
        licenseModel={licenseStatus?.licenseModel}
        folderPathView={folderPathView}
      />
      {!showNewAutoScalingExperience && (
        <Box css={{ marginTop: '$2' }}>
          <CardLicense
            environment={environment || deployment.newEnvironment}
            isRedeploy={isRedeploy}
            licenses={deployment.licenses}
            licenseStatus={licenseStatus}
          />
        </Box>
      )}
    </Elements.Box>
  );
}

DeployPipeline.propTypes = {
  environment: PropTypes.string.isRequired,
  deployment: PropTypes.shape({
    licenses: PropTypes.number.isRequired,
    newEnvironment: PropTypes.string.isRequired,
    licenseStatus: PropTypes.shape({
      licenseModel: PropTypes.string.isRequired
    }).isRequired
  }).isRequired,
  isRedeploy: PropTypes.bool.isRequired,
  folderPathView: PropTypes.bool.isRequired,
  triggers: PropTypes.objectOf({}).isRequired
};

export default DeployPipeline;
